import CartModel from '../models/cart/cart'

export default class CartStore {
  constructor({ embed, shop, catalog, cart, order = null, paymentMethods = null, tables = null, api }) {
    this.embed = embed;
    this.shop = shop;
    this.catalog = catalog;
    this.categories = catalog.categories;
    this.cart = cart;
    this.tables = tables;

    this.tableNumber = this.cart.tableNumber;

    this.order = order;
    this.paymentMethods = paymentMethods;

    this.api = api;
  }

  get actions() {
    return {
      addToCart: this.addToCart.bind(this),
      checkout: this.checkout.bind(this),
      confirm: this.confirm.bind(this),
      getOrder: this.getOrder.bind(this),
      getPaymentMethods: this.getPaymentMethods.bind(this),
      reset: this.reset.bind(this),
      updateCart: this.updateCart.bind(this)
    }
  }

  get name() { 
    return 'sayl-oat';
  }

  get mutations() { 
    return {
      setCart: this.setCart.bind(this),
      setOrder: this.setOrder,
      setPaymentMethods: this.setPaymentMethods,
      setTableNumber: this.setTableNumber.bind(this)
    }
  }

  get state() {
    return {
      embed: this.embed,
      shop: this.shop,
      catalog: this.catalog,
      categories: this.categories,
      cart: this.cart,
      order: this.order,
      paymentMethods: this.paymentMethods,
      tables: this.tables
    }
  }

  setCart(state, cart) {
    if(this.tableNumber !== null) {
      cart.tableNumber = this.tableNumber;
    }
    state.cart = cart;
  }

  setOrder(state, order) {
    state.order = order;
  }

  setPaymentMethods(state, paymentMethods) {
    state.paymentMethods = paymentMethods;
  }

  setTableNumber(state, tableNumber) {
    this.tableNumber = tableNumber;
    state.cart.tableNumber = tableNumber;
    this.api.table.post({ table: tableNumber.toString() });
  }

  addToCart({ state, commit }, item){
    return new Promise((resolve, reject) => {
      state.cart.add(item).then((c) => {
        commit('setCart', c);
      }).catch(reject);
    });
  }

  checkout({ state, commit }) {
    return new Promise((resolve, reject) => {
      this.api.checkout.post({ 
        cart: state.cart 
      }).then((data) => {
        if(data.cart && !['', null, undefined].includes(data.cart)) {
          const tmp = new CartModel(CartModel.fromJSON(data.cart));
          tmp.api = state.cart.api;
          commit("setCart", tmp);
        }

        commit('setOrder', data.order);
        resolve(data.order);
      }).catch(reject);
    });
  }

  getOrder({ state, commit }, {order_id}) {
    return new Promise((resolve, reject) => {
      this.api.checkout.view({ order_id }).then((order) => {
        commit('setOrder', order);
        resolve(order);
      }).catch(reject);
    }); 
  }

  confirm({ state }, {user, payment, comment}) {
    return new Promise((resolve, reject) => {
      this.api.user.put({ user }).then(() => {
        if(comment !== null) {
          this.api.user.comment({ orderId: state.order.id, comment}).then(() => {
            this.api.checkout.reset({ 
              orderId: state.order.id 
            }).then(() => {
              this.api.pm.post({ 
                orderId: state.order.id, 
                method: payment 
              }).then((res) => {
                window.location = res.url;
               // resolve(res);
              }).catch(reject);
            }).catch(reject);
          }).catch(reject);
        } else {
          this.api.checkout.reset({ 
            orderId: state.order.id 
          }).then(() => {
            this.api.pm.post({ 
              orderId: state.order.id, 
              method: payment 
            }).then((res) => {
              window.location = res.url;
            // resolve(res);
            }).catch(reject);
          }).catch(reject);
        }
      }).catch(reject);
    });
  }

  getPaymentMethods({ state, commit }, payload) {
    return new Promise((resolve, reject) => {
      this.api.pm.get(payload).then((paymentMethods) => {
        commit('setPaymentMethods', paymentMethods);;
        resolve(paymentMethods);
      }).catch(reject);
    });
  }

  reset({ state, commit }) {
    return new Promise((resolve, reject) => {
      localStorage.removeItem('cart_id');
      resolve();
    });
  }

  updateCart({ state, commit }, item) {
    state.cart.update(item).then((c) => {
      commit('setCart', c);
    });
  }

  toStore() {
    return {
      name: this.name,
      state: this.state,
      actions: this.actions,
      mutations: this.mutations
    }
  }
}